import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { Role } from '../api/role';
import { RokezzzLocalStorageService } from 'src/app/rokezzz/local-storage/services/local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class RokezzzAuthorizationService {
    public static readonly adminRole: string = 'ADMIN';
    public static readonly employeeRole: string = 'EMPLOYEE';

    private static readonly tokenKey: string = 'token';
    private static readonly rolesKey: string = 'roles';

    private static roles: Role[] | null = null;

    public constructor(
        protected readonly rokezzzLocalStorageService: RokezzzLocalStorageService,
    ) { }

    public static isLoggedIn(): boolean {
        return globals.localStorageService?.getItem(RokezzzAuthorizationService.tokenKey) !== null;
    }

    public static hasRole(role: string): boolean {
        const roles: Role[] = RokezzzAuthorizationService.getRoles();

        return RokezzzAuthorizationService.isLoggedIn() && roles.filter(e => e.code === role).length > 0;
    }

    private static getRoles(): Role[] {
        if (RokezzzAuthorizationService.roles === null) {
            RokezzzAuthorizationService.roles = JSON.parse(
                globals.localStorageService?.getItem(RokezzzAuthorizationService.rolesKey) ?? '[]'
            ) as Role[];
        }

        return RokezzzAuthorizationService.roles;
    }

    public isLoggedIn(): boolean {
        return RokezzzAuthorizationService.isLoggedIn();
    }

    public getAuthorization(): string {
        return this.rokezzzLocalStorageService.getItem(RokezzzAuthorizationService.tokenKey) ?? '';
    }

    public setAuthorization(authorization: string): void {
        this.rokezzzLocalStorageService.setItem(RokezzzAuthorizationService.tokenKey, authorization);
    }

    public removeAuthorization(): void {
        this.rokezzzLocalStorageService.removeItem(RokezzzAuthorizationService.tokenKey);
    }

    public getRoles(): Role[] {
        return RokezzzAuthorizationService.getRoles();
    }

    public setRoles(roles: Role[]): void {
        RokezzzAuthorizationService.roles = roles;
        this.rokezzzLocalStorageService.setItem(RokezzzAuthorizationService.rolesKey, JSON.stringify(roles));
    }

    public removeRoles(): void {
        RokezzzAuthorizationService.roles = null;
        this.rokezzzLocalStorageService.removeItem(RokezzzAuthorizationService.rolesKey);
    }

    public isAdmin(): boolean {
        return this.getRoles().filter(e => e.code === RokezzzAuthorizationService.adminRole).length > 0;
    }

    public isEmployee(): boolean {
        return this.getRoles().filter(e => e.code === RokezzzAuthorizationService.employeeRole).length > 0;
    }
}
